import React from 'react';
import { ASSETS_TYPE, FILTER_PARAMS } from '@/types/shared/navigation-tabs.enums';
import { Highlight } from '@/components/uiKit/Highlight';
import { useSearchParams } from 'react-router-dom';
import { Asset } from '@/types/models/assets.types';
import { AssetPreviewItemTitle, DataNotReceivedBadge } from '../../shared';
import { cn } from '@/lib/utils';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';

interface HeaderSectionProps {
  className: string;
  asset: Asset;
  assetsType: ASSETS_TYPE | undefined;
}

const HeaderSectionComponent = ({ className, asset, assetsType }: HeaderSectionProps) => {
  const [params] = useSearchParams();
  const searchByType = assetsType
    ? useSelector((state: RootState) => state.assetsPreview.searchByAssetType?.[assetsType])
    : null;

  return (
    <div className={cn(className, `min-h-8`)}>
      <div className={`${asset.not_monitored && !!asset.reasons_for_na?.length ? 'max-w-[50%]' : 'max-w-[80%]'}`}>
        <AssetPreviewItemTitle
          title={
            <Highlight
              searchTerm={params.get(FILTER_PARAMS.GENERAL_SEARCH) || searchByType || ''}
              text={`${asset.asset_ui_name} ${
                assetsType === ASSETS_TYPE.MOBILE ? `- ${asset.asset_supplier} ${asset.asset_model}` : ''
              }`}
            />
          }
        />
        {/* <div className="h-6">{asset.health_status_changed && <StatusChanged />}</div> */}
      </div>
      <div className="h-full items-start mt-[-0.3rem]">
        {asset.not_monitored && (
          <DataNotReceivedBadge
            reasonForNa={asset.reasons_for_na}
            showReasonForNa={asset?.reasons_for_na && asset?.reasons_for_na?.length > 0}
          />
        )}
      </div>
    </div>
  );
};

export const HeaderSection = React.memo(HeaderSectionComponent);
